import {
  Button,
  HStack,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from '@mybridge/ui';
import { forwardRef, useContext } from 'react';
import { DiskContext } from '../context';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const DiskDeleteMultipleFilesModal = forwardRef(({ ...props }, ref) => {
  const {
    multiDeleteDisc,
    deleteMultipleFileFolder,
    deleteFileFolder,
    selectedFile,
    deleteMultipleFileFolderLoading,
    selectedFiles,
  } = useContext(DiskContext);
  const { t } = useTranslator();
  const onSubmit = () => {
    const ids = selectedFiles;
    if(ids?.length===1){
      deleteFileFolder(selectedFile);
    }else{
      deleteMultipleFileFolder({ ids, type: 'f' });
    }
  };
  return (
    <>
      <Modal isCentered {...multiDeleteDisc}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalHeader>
            <HStack alignItems={'flex-start'}>
              <Stack spacing={0} gap={0}>
                <Heading size="md">{t('myDisk.deleteMultipleItems') || "Delete multiple items?"}</Heading>
              </Stack>
            </HStack>
          </ModalHeader>
          <ModalBody>
            <Text>{t('myDisk.confirmRemoveItems') || "Are you sure you want to remove the selected items?"}</Text>
          </ModalBody>
          <ModalFooter>
            <HStack>
              <Button borderRadius="full" onClick={multiDeleteDisc?.onClose} variant="secondary">
                {t('buttons.cancel') || "Cancel"}
              </Button>
              <Button
                borderRadius="full"
                isLoading={deleteMultipleFileFolderLoading}
                onClick={onSubmit}
                colorScheme="red"
              >
                {t('profile.remove') || "Remove"}
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
});
